<template>
  <div class="container">
    <div class="bg-blue"></div>
    <div class="img-box img-box-mobile"></div>
    <div class="bg-orange bg-orange-mobile">
      <div class="info">
        <div class="contact">
          {{ $t("infoCollectContactMobile1") }}
        </div>
      </div>
    </div>
    <div class="form-box">
      <div class="form" id="loading-form">
        <div v-show="form_show">
          <div class="title">
            {{ $t("infoCollectTitle") }}
          </div>
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
            <el-form-item prop="country">
              <el-select
                v-model="ruleForm.country"
                :placeholder="$t('infoCollectForm1')"
                style="width: 100%"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in country_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              prop="country_remark"
              v-show="ruleForm.country.value == 'OTHER'"
            >
              <el-input
                :placeholder="$t('infoCollectForm12')"
                v-model="ruleForm.country_remark"
                onkeyup="this.value=this.value.replace(/[0-9]/g,'')"
                @change="
                  (value) => formatInput(value, ['ruleForm', 'country_remark'])
                "
              ></el-input>
            </el-form-item>
            <el-form-item prop="title">
              <el-select
                v-model="ruleForm.title"
                :placeholder="$t('infoCollectForm2')"
                style="width: 100%"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in title_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="no-ele">
              <el-col :span="11">
                <el-form-item prop="first_name" style="margin-bottom: 0">
                  <el-input
                    :placeholder="$t('infoCollectForm3')"
                    v-model="ruleForm.first_name"
                    onkeyup="this.value=this.value.replace(/[0-9]/g,'')"
                    @change="
                      (value) => formatInput(value, ['ruleForm', 'first_name'])
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" style="color: transparent">-</el-col>
              <el-col :span="11">
                <el-form-item prop="last_name" style="margin-bottom: 0">
                  <el-input
                    :placeholder="$t('infoCollectForm4')"
                    v-model="ruleForm.last_name"
                    onkeyup="this.value=this.value.replace(/[0-9]/g,'')"
                    @change="
                      (value) => formatInput(value, ['ruleForm', 'last_name'])
                    "
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-form-item>
            <el-form-item prop="email">
              <el-input
                :placeholder="$t('infoCollectForm5')"
                v-model="ruleForm.email"
              ></el-input>
            </el-form-item>
            <el-form-item prop="phone" style="margin-bottom: 30px">
              <el-input
                :placeholder="$t('infoCollectForm6')"
                v-model="ruleForm.phone"
                onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                @change="(value) => formatInput(value, ['ruleForm', 'phone'])"
              >
                <el-input
                  class="pre-input"
                  slot="prepend"
                  v-model="ruleForm.country.phone_code"
                  onkeyup="this.value=this.value.replace(/[^0-9]/g,'')"
                  @change="(value) => formatInput(value, ['ruleForm', 'country', 'phone_code'])"
                  :maxlength="6"
                  v-if="ruleForm.country.value"
                ></el-input>
                <!-- <template slot="prepend" v-if="ruleForm.country.phone_code">{{
                ruleForm.country.phone_code
              }}</template> -->
              </el-input>
            </el-form-item>
            <!-- <el-form-item prop="contact_preference">
              <el-select
                v-model="ruleForm.contact_preference"
                :placeholder="$t('infoCollectForm7')"
                style="width: 100%"
                :popper-append-to-body="false"
              >
                <el-option
                  v-for="item in contact_preference_list"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item prop="protocol" class="no-ele form-checkbox">
              <el-checkbox-group v-model="ruleForm.protocol">
                <el-checkbox label="agree">
                  {{ $t("infoCollectForm8") }}
                  <a href="/#/privacyPolicy" target="_blank">{{
                    $t("infoCollectForm9")
                  }}</a>
                  {{ $t("infoCollectForm8-1") }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
            <el-form-item class="no-ele">
              <el-checkbox
                v-model="ruleForm.marketing"
                true-label="Y"
                false-label="N"
              >
                {{ $t("infoCollectForm13") }}
              </el-checkbox>
            </el-form-item>
            <el-form-item class="no-ele">
              <div class="btn" @click="submitForm('ruleForm')">
                <span>{{ $t("infoCollectForm10") }}</span>
                <img
                  src="../../assets/images/infoCollection/Subtract.png"
                  alt=""
                />
              </div>
            </el-form-item>
          </el-form>
        </div>
        <div class="form-after-submit" v-show="!form_show">
          <img src="../../assets/images/infoCollection/Vector.png" alt="" />
          <h4>{{ $t("infoCollectDone1") }}</h4>
          <p>
            {{ $t("infoCollectDone2") }}
          </p>
          <a class="btn" href="/" target="_blank">
            <span>{{ $t("infoCollectForm11") }}</span>
            <img src="../../assets/images/infoCollection/Subtract.png" alt="" />
          </a>
        </div>
      </div>
    </div>
    <div class="img-box">
      <div></div>
    </div>
    <div class="bg-orange">
      <div class="info">
        <div class="contact" :class="{ 'contact-de': $t('lang') == 'de' }">
          {{ $t("infoCollectContact1") }}
        </div>
        <!-- <div class="tel">Tel: +49 8913072682</div> -->
        <div class="desc">
          {{ $t("infoCollectContact2") }}
        </div>
      </div>
    </div>
    <div class="bg-orange bg-orange-mobile">
      <div class="info">
        <div class="desc">
          {{ $t("infoCollectContact2") }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Message, Loading } from "element-ui";
const axios = require("axios");
export default {
  data() {
    return {
      form_show: false,
      ruleForm: {
        country: {
          label: "",
          value: "",
          phone_code: "",
        },
        country_remark: "",
        title: "",
        first_name: "",
        last_name: "",
        contact_preference: "",
        email: "",
        phone: "",
        protocol: [],
        marketing: "N",
      },
      phone_code_list: [
        211, 1, 590, 381, 44, 599, 358, 382, 0, 263, 260, 967, 212, 681, 1340,
        1284, 84, 58, 678, 998, 598, 971, 380, 256, 688, 1649, 7370, 90, 216,
        1868, 676, 690, 228, 670, 66, 255, 992, 886, 963, 41, 46, 268, 47, 597,
        249, 94, 34, 27, 252, 677, 386, 421, 65, 232, 248, 221, 966, 239, 378,
        684, 1784, 508, 1758, 1869, 290, 250, 70, 40, 262, 974, 1787, 351, 48,
        63, 51, 595, 675, 507, 970, 680, 92, 968, 1670, 672, 683, 234, 227, 505,
        64, 687, 31, 977, 674, 264, 95, 258, 1664, 976, 377, 373, 691, 52, 269,
        230, 222, 596, 692, 356, 223, 960, 60, 265, 261, 389, 853, 352, 370,
        423, 218, 231, 266, 961, 371, 856, 996, 965, 82, 850, 686, 254, 7, 962,
        81, 1876, 39, 972, 353, 964, 98, 62, 91, 354, 36, 852, 504, 509, 592,
        245, 224, 502, 1671, 1473, 299, 30, 350, 233, 49, 995, 220, 241, 689,
        594, 33, 679, 298, 500, 251, 372, 291, 240, 503, 20, 593, 1809, 1767,
        253, 45, 420, 357, 53, 385, 225, 506, 682, 242, 57, 61, 86, 56, 235,
        236, 1345, 238, 237, 855, 257, 226, 359, 673, 246, 55, 267, 387, 591,
        975, 1441, 229, 501, 32, 375, 1246, 880, 973, 1242, 994, 43, 297, 374,
        54, 1268, 1264, 244, 376, 1684, 213, 355, 93,
      ],
    };
  },
  computed: {
    phoneCodeValid() {
      let phone_code = this.ruleForm.country.phone_code.replace(/[^0-9]/g, "");
      if (phone_code == "0") {
        return true;
      } else if (phone_code) {
        let not_zero_first_index = phone_code.indexOf((code) => code != "0");
        phone_code = phone_code.substring(not_zero_first_index);
        return this.phone_code_list.some((code) => code == phone_code);
      } else {
        return false;
      }
    },
    rules() {
      return {
        country: [
          {
            trigger: "change",
            validator: (rule, value, callback) => {
              if (!value.value) {
                callback(new Error(this.$t("infoCollectValid1")));
              }
              callback();
            },
          },
        ],
        country_remark: [
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (this.ruleForm.country.value == "OTHER") {
                if (!value) {
                  callback(new Error(this.$t("infoCollectValid9")));
                }
                callback();
              }
              callback();
            },
          },
        ],
        title: [
          {
            required: true,
            message: this.$t("infoCollectValid2"),
            trigger: "change",
          },
        ],
        first_name: [
          {
            required: true,
            message: this.$t("infoCollectValid3"),
            trigger: "blur",
          },
        ],
        last_name: [
          {
            required: true,
            message: this.$t("infoCollectValid4"),
            trigger: "blur",
          },
        ],
        contact_preference: [
          {
            required: true,
            message: this.$t("infoCollectValid5"),
            trigger: "change",
          },
        ],
        email: [
          {
            required: true,
            type: "email",
            message: this.$t("infoCollectValid6"),
            trigger: "blur",
          },
        ],
        phone: [
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              let phone_value = value.replace(/[^0-9]/g, "");
              if (phone_value && this.phoneCodeValid) {
                callback();
              } else {
                callback(new Error(this.$t("infoCollectValid7")));
              }
            },
          },
        ],
        protocol: [
          {
            required: true,
            type: "array",
            message: this.$t("infoCollectValid8"),
            trigger: "change",
          },
        ],
      };
    },
    country_list() {
      return [
        {
          label: this.$t("infoCollectCountry1"),
          value: "DE",
          phone_code: "49",
        },
        {
          label: this.$t("infoCollectCountry2"),
          value: "FR",
          phone_code: "33",
        },
        {
          label: this.$t("infoCollectCountry3"),
          value: "CH",
          phone_code: "41",
        },
        {
          label: this.$t("infoCollectCountry4"),
          value: "GB",
          phone_code: "44",
        },
        {
          label: this.$t("infoCollectCountry5"),
          value: "SE",
          phone_code: "46",
        },
        {
          label: this.$t("infoCollectCountry6"),
          value: "ES",
          phone_code: "34",
        },
        {
          label: this.$t("infoCollectCountry7"),
          value: "PT",
          phone_code: "351",
        },
        {
          label: this.$t("infoCollectCountry8"),
          value: "IL",
          phone_code: "972",
        },
        {
          label: this.$t("infoCollectCountry9"),
          value: "OTHER",
          phone_code: "",
        },
      ];
    },
    title_list() {
      if (this.$t("lang") == "de") {
        return [
          {
            label: this.$t("infoCollectTitle1"),
            value: "Mr",
          },
          {
            label: this.$t("infoCollectTitle2"),
            value: "Mrs",
          },
        ];
      }
      return [
        {
          label: this.$t("infoCollectTitle1"),
          value: "Mr",
        },
        {
          label: this.$t("infoCollectTitle2"),
          value: "Mrs",
        },
        {
          label: this.$t("infoCollectTitle3"),
          value: "Miss",
        },
      ];
    },
    contact_preference_list() {
      return [
        // {
        //   label: "Home Tel",
        //   value: "Phone",
        // },
        {
          label: this.$t("infoCollectForm5"),
          value: "Email",
        },
        {
          label: this.$t("infoCollectForm6"),
          value: "MobilePhone",
        },
        // {
        //   label: "Fax",
        //   value: "Fax",
        // },
        // {
        //   label: "Mail",
        //   value: "Mail",
        // },
      ];
    },
    computedLang() {
      return this.$t("lang");
    },
  },
  methods: {
    formatInput(value, data_key_list) {
      let _this = this;
      for (let i = 0; i < data_key_list.length; i += 1) {
        if (i == data_key_list.length - 1) {
          console.log("value: ", value);
          console.log("_this: ", _this[data_key_list[i]]);
          if (value !== _this[data_key_list[i]]) {
            _this[data_key_list[i]] = value;
          }
          break;
        } else {
          _this = _this[data_key_list[i]];
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let loading = Loading.service({
            target: "#loading-form",
          });
          axios
            .post(
              "https://uat.gwm-eu.com/api/v1/external/leads/leadspool?appkey=1&sign=d95b5307a71c4a3d0f32f559d4808a1d",
              {
                interestBrand: "OL",
                type: "CapitalRetention",
                leadsSource: "Online",
                leadsSubsource: "OfficialWebsite",
                typeOfCustomer: "Personal",
                country:
                  this.ruleForm.country.value == "OTHER"
                    ? ""
                    : this.ruleForm.country.value,
                salutation: this.ruleForm.title,
                firstName: (this.ruleForm.first_name =
                  this.ruleForm.first_name.replace(/[0-9]/g, "")),
                lastName: (this.ruleForm.last_name =
                  this.ruleForm.last_name.replace(/[0-9]/g, "")),
                // contactPreference: this.ruleForm.contact_preference,
                email: this.ruleForm.email,
                mobileCountryCode: (this.ruleForm.country.phone_code =
                  this.ruleForm.country.phone_code.replace(/[^0-9]/g, "")),
                mobile: (this.ruleForm.phone = this.ruleForm.phone.replace(
                  /[^0-9]/g,
                  ""
                )),
                address:
                  this.ruleForm.country.value == "OTHER"
                    ? (this.ruleForm.country_remark =
                        this.ruleForm.country_remark.replace(/[0-9]/g, ""))
                    : "",
                marketing: this.ruleForm.marketing,
              }
            )
            .finally(() => {
              loading.close();
            })
            .then((res) => {
              console.log(res);
              if (res.data.code == 200) {
                this.form_show = false;
              } else {
                Message.error(res.data.msg);
              }
            })
            .catch(() => {
              Message.error("Timeout!");
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  watch: {
    computedLang(new_val) {
      if (new_val == "de" && this.ruleForm.title == "Miss") {
        this.ruleForm.title = "";
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@media (max-width: 1600px) {
}
.container {
  position: relative;
  margin-top: -60px;
  text-align: left;
  overflow: hidden;
  @media (max-width: 1200px) {
    margin-top: 0;
  }
  .bg-blue {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 70%;
    background-color: #c6e7fb;
    z-index: -2;
    @media (max-width: 1200px) {
      position: static;
      width: 90%;
      height: 173px;
    }
  }
  .bg-orange {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 500px;
    text-align: left;
    background-color: rgba(255, 138, 59, 1);
    z-index: -1;
    overflow: hidden;
    &.bg-orange-mobile {
      display: none;
    }
    @media (max-width: 1200px) {
      display: none;
      position: static;
      height: auto;
      padding: 15px;
      &.bg-orange-mobile {
        display: block;
      }
    }
    .info {
      position: absolute;
      right: 0;
      bottom: 0;
      left: 50%;
      height: 100%;
      padding: 20px 40px 0;
      color: #fff;
      @media (max-width: 1200px) {
        position: static;
        padding: 0;
      }
      .contact {
        margin-bottom: 20px;
        line-height: 35px;
        font-size: 25px;
        font-family: NexaBold;
        white-space: pre-line;
        &.contact-de {
          font-size: 24px;
          line-height: 30px;
        }
        @media (max-width: 1600px) {
          font-size: 24px;
          line-height: 30px;
        }
        @media (max-width: 1200px) {
          margin-bottom: 0;
          font-size: 20px;
          line-height: 30px;
        }
      }
      .tel {
        margin-bottom: 30px;
        line-height: 35px;
        font-size: 25px;
        font-family: NexaBold;
        font-weight: bold;
        @media (max-width: 1200px) {
          font-size: 16px;
          line-height: 24px;
        }
      }
      .desc {
        line-height: 30px;
        font-size: 25px;
        font-family: NexaLight;
        font-weight: 300;
        white-space: pre-line;
        @media (max-width: 1600px) {
          font-size: 22px;
          line-height: 30px;
        }
        @media (max-width: 1200px) {
          font-size: 20px;
          line-height: 30px;
        }
      }
    }
  }
  .form-box {
    display: inline-block;
    width: 50%;
    padding-left: var(--retain-capital-form-margin-left);
    vertical-align: middle;
    @media (max-width: 1200px) {
      width: 100%;
      padding-left: 0;
    }
    .form {
      width: 100%;
      margin-top: 40px;
      margin-bottom: 140px;
      padding: 0 54px;
      text-align: left;
      background-color: #fff;
      overflow: hidden;
      @media (max-width: 1200px) {
        width: 100%;
        height: auto;
        padding: 15px;
        margin: 0;
        background-color: rgba(255, 138, 59, 1);
        > div {
          padding: 15px;
          background-color: #fff;
          overflow: hidden;
        }
      }
      .title {
        margin: 30px 0;
        line-height: 45px;
        color: #333;
        font-size: 30px;
        font-family: NexaBold;
        font-weight: 700;
        text-align: center;
        @media (max-width: 1200px) {
          margin: 20px 0;
          font-size: 20px;
          line-height: 30px;
        }
      }
      .btn {
        width: 330px;
        height: 70px;
        line-height: 60px;
        margin: 0 auto;
        text-align: center;
        font-size: 22px;
        color: rgba(51, 51, 51, 1);
        font-family: NexaBold;
        font-weight: bold;
        border: 2px solid #333;
        border-radius: 50px;
        cursor: pointer;
        @media (max-width: 1200px) {
          width: 70%;
          height: 48px;
          line-height: 40px;
          font-size: 14px;
          > img {
            width: 18px;
          }
        }
        > * {
          display: inline-block;
          margin: 0 10px;
          vertical-align: middle;
          @media (max-width: 1200px) {
            margin: 0 8px;
          }
        }
      }
      .pre-input {
        position: relative;
        width: 125px;
        &::before {
          content: "(+";
          position: absolute;
          left: 0;
          z-index: 1;
        }
        &::after {
          content: ")";
          position: absolute;
          right: 0;
          z-index: 1;
        }
        @media (max-width: 1200px) {
          width: 80px;
          &::before,
          &::after {
            font-size: 16px;
          }
        }
      }
      .form-after-submit {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 1000px;
        padding: 0 80px;
        > h4 {
          margin: 40px 0;
          line-height: 60px;
          font-family: NexaBold;
          font-weight: bold;
          font-size: 36px;
          color: #ff8a3b;
        }
        > p {
          margin-bottom: 90px;
          line-height: 35px;
          font-family: NexaBold;
          font-weight: bold;
          font-size: 22px;
          text-align: center;
          color: #000;
        }
        @media (max-width: 1200px) {
          padding: 0 15px;
          height: 400px;
          > img {
            width: 55px;
          }
          > h4 {
            margin: 20px 0;
            font-size: 20px;
            line-height: 30px;
          }
          > p {
            margin-bottom: 30px;
            font-size: 16px;
            line-height: 26px;
            font-weight: 300;
          }
        }
      }
    }
  }
  .img-box {
    position: relative;
    display: inline-block;
    width: 50%;
    // height: 590px;
    padding: 15% 0;
    margin-top: -500px;
    vertical-align: middle;
    &.img-box-mobile {
      display: none;
    }
    > div {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: url("../../assets/images/infoCollection/img.png") no-repeat
        50% bottom/ cover;
    }
    @media (max-width: 1200px) {
      display: none;
      position: static;
      width: 90%;
      margin: -150px 0 20px auto;
      height: 224px;
      background: url("../../assets/images/infoCollection/img_mobile.png")
        no-repeat right bottom/ contain;
      &.img-box-mobile {
        display: block;
      }
    }
  }

  ::placeholder {
    line-height: 35px;
    font-size: 22px;
    color: #999;
    font-family: NexaLight;
    font-weight: 300;
    @media (max-width: 1200px) {
      font-size: 16px;
      line-height: 26px;
    }
  }

  // element
  .el-form-item {
    position: relative;
    margin-bottom: 60px;
    @media (max-width: 1200px) {
      margin-bottom: 30px;
    }
    &:not(.no-ele):before {
      content: "*";
      position: absolute;
      top: 10px;
      left: 10px;
      color: rgba(152, 151, 151, 1);
      font-size: 24px;
      line-height: 24px;
      z-index: 1;
      @media (max-width: 1200px) {
        top: 19px;
        font-size: 16px;
        line-height: 16px;
      }
    }
    &.form-checkbox {
      margin-bottom: 30px;
      @media (max-width: 1200px) {
        margin-bottom: 20px;
      }
      ::v-deep .el-form-item__content {
        line-height: 20px;
      }
    }
  }
  .pre-input ::v-deep .el-input__inner {
    margin-top: -1px;
    padding: 0;
    text-align: center;
    border: none;
  }
  ::v-deep .el-checkbox__input {
    line-height: 30px;
    vertical-align: top;
  }
  ::v-deep .el-checkbox__label {
    line-height: 30px;
    font-size: 18px;
    color: #000000;
    font-family: NexaLight;
    font-weight: 300;
    vertical-align: top;
    white-space: normal;
    @media (max-width: 1200px) {
      font-size: 12px;
      line-height: 26px;
    }
    > a {
      color: #5091cd;
      text-decoration: none;
    }
  }
  ::v-deep .el-checkbox__inner {
    border-color: #3f5864;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner {
    background-color: #5091cd;
    border-color: #5091cd;
  }
  ::v-deep .el-input__inner {
    position: relative;
    line-height: 35px;
    padding-left: 30px;
    color: #333;
    font-size: 22px;
    font-family: NexaLight;
    font-weight: 300;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
    border-color: rgba(153, 153, 153, 0.4) !important;
    vertical-align: top;
    @media (max-width: 1200px) {
      line-height: 26px;
      font-size: 16px;
    }
  }
  ::v-deep .el-select-dropdown__item {
    height: 70px;
    line-height: 70px;
    font-size: 22px;
    font-family: NexaLight;
    font-weight: 300;
    color: #999;
    border-bottom: 1px solid rgba(153, 153, 153, 0.2);
    @media (max-width: 1200px) {
      height: 50px;
      line-height: 50px;
      font-size: 16px;
    }
    &.hover {
      color: rgba(51, 51, 51, 1);
      background-color: transparent;
    }
    &:last-child {
      border-bottom: none;
    }
  }
  ::v-deep .el-select .el-input .el-select__caret {
    font-size: 24px;
    @media (max-width: 1200px) {
      font-size: 12px;
    }
  }
  ::v-deep .el-form-item__error {
    line-height: 24px;
    font-size: 14px;
    color: rgba(250, 85, 85, 1);
    font-family: NexaLight;
    font-weight: 300;
    @media (max-width: 1200px) {
      line-height: 20px;
      font-size: 12px;
    }
  }
  ::v-deep .el-input-group__prepend {
    line-height: 35px;
    padding-left: 30px;
    padding-right: 0;
    color: #333333;
    font-size: 25px;
    font-family: NexaLight;
    font-weight: 300;
    background: transparent;
    border-top: none;
    border-left: none;
    border-right: none;
    border-radius: 0;
    border-color: rgba(153, 153, 153, 0.4) !important;
  }
  ::v-deep .el-select-dropdown__wrap {
    max-height: 382px;
  }
  .el-checkbox-group {
    @media (max-width: 1200px) {
      line-height: 20px;
    }
  }
}
</style>
<style lang="scss">
:root {
  --retain-capital-form-width: 950px;
  --retain-capital-form-margin-left: 119px;
  @media (max-width: 1600px) {
    --retain-capital-form-width: 750px;
    --retain-capital-form-margin-left: 89px;
  }
  @media (max-width: 1400px) {
    --retain-capital-form-width: 650px;
    --retain-capital-form-margin-left: 49px;
  }
}
</style>